import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LanguageLayout from "./components/LanguageLayout";
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGS } from './i18n';
import Loading from "./pages/Loading";
import './index.css';

const Home = lazy(() => import("./pages/Home"));
const Barbershop = lazy(() => import("./pages/Barbershop"));
const Tattoo = lazy(() => import("./pages/Tattoo"));
const NotFound = lazy(() => import("./pages/NotFound"));

function App() {
  const { i18n } = useTranslation();
  const defaultLang = SUPPORTED_LANGS.includes(i18n.language) ? i18n.language : 'en';

  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        {/* Language-prefixed routes */}
        <Route path="/:lang" element={<LanguageLayout />}>
          <Route index element={<Home />} />
          <Route path="barbershop" element={<Barbershop />} />
          <Route path="tattoo" element={<Tattoo />} />
        </Route>

        {/* Backward-compatible redirects for old URLs */}
        <Route path="/barbershop" element={<Navigate to={`/${defaultLang}/barbershop`} replace />} />
        <Route path="/tattoo" element={<Navigate to={`/${defaultLang}/tattoo`} replace />} />

        {/* Root and catch-all */}
        <Route path="/" element={<Navigate to={`/${defaultLang}`} replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}

export default App;
